import React from 'react';
import { Elements } from '@stripe/react-stripe-js';

import { GatewayProps } from '../../@types';
import { SupportedGateways, SupportedPaymentMethods } from '../../constants';
import { createProviderFactory } from '../../services';

export const Gateway = ({ gateway, method, clientKey, options, children }: GatewayProps) => {
  const { provider, getOptions } = React.useMemo(
    () => (SupportedGateways.STRIPE === gateway ? createProviderFactory(SupportedGateways.STRIPE)
      .createProvider({ publishableKey: clientKey, options }) : {}),
    [clientKey, gateway, options],
  );

  if (
    gateway === SupportedGateways.STRIPE && (
      method === SupportedPaymentMethods.CARD
      || method === SupportedPaymentMethods.APPLEPAY
      || method === SupportedPaymentMethods.GOOGLEPAY
    )) {
    return (
      <Elements options={getOptions(method)} stripe={provider}>
        {children}
      </Elements>
    );
  }
  return (
    <>
      {children}
    </>
  );
};
